module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "target-top__layout"
  }, [_c('v-layout', {
    staticClass: "pa-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "elevation-1",
    staticStyle: {
      "text-align": "center",
      "padding": "0 5px 5px 20px",
      "margin-bottom": "10px"
    },
    attrs: {
      "md4": "",
      "lg3": "",
      "xs12": ""
    }
  }, [_c('img', {
    staticClass: "pa-1",
    attrs: {
      "height": "320",
      "src": _vm.apiUrl + 'shared/ajax/get_compound_image.php?compound_id=' + _vm.$route.params.compound
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "md12": "",
      "lg12": "",
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "pr-3"
  }, [_c('div', {
    staticClass: "carousel-table-value"
  }, [_vm._v("Synonyms")]), _vm._v(" "), _c('div', {
    staticClass: "carousel-table-title"
  }, [(!_vm.compound2.compound_names.length) ? _c('span', [_vm._v(" - ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.compound2.compound_names), function(name, i) {
    return (_vm.compound2.compound_names.length) ? _c('span', {
      key: i
    }, [_vm._v("\n                " + _vm._s(name) + "\n                "), (i < _vm.compound2.compound_names.length - 1) ? _c('span', [_vm._v(", ")]) : _vm._e()]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "pr-3"
  }, [_c('div', {
    staticClass: "carousel-table-value"
  }, [_vm._v("Molecular Formula")]), _vm._v(" "), _c('div', {
    staticClass: "carousel-table-title"
  }, [_vm._v(_vm._s(_vm.compound2.MOLECULAR_FORMULA))])]), _vm._v(" "), _c('div', {
    staticClass: "pr-3"
  }, [_c('div', {
    staticClass: "carousel-table-value"
  }, [_vm._v("InChl")])]), _vm._v(" "), _c('div', {
    staticClass: "pr-3"
  }, [_c('div', {
    staticClass: "carousel-table-title",
    staticStyle: {
      "overflow": "auto"
    }
  }, [_vm._v(_vm._s(_vm.compound2.INCHI))])]), _vm._v(" "), _c('div', {
    staticClass: "pr-3"
  }, [_c('div', {
    staticClass: "carousel-table-value"
  }, [_vm._v("Cross References")])]), _vm._v(" "), _c('div', {
    staticClass: "pr-3"
  }, [_c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%",
      "border-spacing": "0",
      "border": "1px solid #4DB6AC"
    }
  }, _vm._l((_vm.compound2.easy_xrefs), function(link, key) {
    return _c('tr', {
      key: key
    }, [_c('td', {
      staticClass: "carousel-table-value-2"
    }, [_vm._v(_vm._s(link[0]))]), _vm._v(" "), (!link[1].length) ? _c('td', {
      staticClass: "carousel-table-title-3"
    }, [_vm._v(_vm._s(link[2]))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "carousel-table-title-3",
      staticStyle: {
        "padding": "2px 0 1px 0"
      }
    }, [(link[1].length) ? _c('a', {
      attrs: {
        "href": link[1],
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(link[2]))]) : _vm._e()])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "pr-3",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%",
      "border-spacing": "0",
      "border": "1px solid #4DB6AC"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "carousel-table-value"
  }, [_vm._v("Commercially Available")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "carousel-table-title"
  }, [_vm._v(_vm._s(_vm.compound2.commercially_available))])])])])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": "",
      "lg12": "",
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "pr-3",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%",
      "border-spacing": "0",
      "border": "1px solid #4DB6AC"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "carousel-table-value"
  }, [_c('td', {
    staticClass: "carousel-table-value"
  }, [_vm._v("Properties")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "pr-3",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%",
      "border-spacing": "0",
      "border": "1px solid #4DB6AC"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "carousel-table-value-2"
  }, [_vm._v("Molecular Weight")]), _vm._v(" "), _c('td', {
    staticClass: "carousel-table-title-3",
    style: ({
      color: _vm.compound2.MOLECULAR_WEIGHT < _vm.compound2.property_thresholds.MOLECULAR_WEIGHT ? 'green' : 'red'
    })
  }, [_vm._v(_vm._s(parseFloat(_vm.compound2.MOLECULAR_WEIGHT).toFixed(1)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "carousel-table-value-2"
  }, [_vm._v("ALOGP")]), _vm._v(" "), _c('td', {
    staticClass: "carousel-table-title-3",
    style: ({
      color: _vm.compound2.ALOGP < _vm.compound2.property_thresholds.ALOGP ? 'green' : 'red'
    })
  }, [_vm._v(_vm._s(parseFloat(_vm.compound2.ALOGP).toFixed(1)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "carousel-table-value-2"
  }, [_vm._v("HBOND DONORS")]), _vm._v(" "), _c('td', {
    staticClass: "carousel-table-title-3",
    style: ({
      color: _vm.compound2.HBOND_DONORS < _vm.compound2.property_thresholds.HBOND_DONORS ? 'green' : 'red'
    })
  }, [_vm._v(_vm._s(_vm.compound2.HBOND_DONORS))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "carousel-table-value-2"
  }, [_vm._v("HBOND ACCEPTORS")]), _vm._v(" "), _c('td', {
    staticClass: "carousel-table-title-3",
    style: ({
      color: _vm.compound2.HBOND_ACCEPTORS < _vm.compound2.property_thresholds.HBOND_ACCEPTORS ? 'green' : 'red'
    })
  }, [_vm._v(_vm._s(_vm.compound2.HBOND_ACCEPTORS))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "carousel-table-value-2"
  }, [_vm._v("ATOMS")]), _vm._v(" "), _c('td', {
    staticClass: "carousel-table-title-3",
    style: ({
      color: _vm.compound2.ATOMS < _vm.compound2.property_thresholds.ATOMS ? 'green' : 'red'
    })
  }, [_vm._v(_vm._s(_vm.compound2.ATOMS))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "carousel-table-value-2"
  }, [_vm._v("CONTAINS TOXICOPHORE")]), _vm._v(" "), _c('td', {
    staticClass: "carousel-table-title-3",
    style: ({
      color: _vm.compound2.CONTAINS_TOXICOPHORE ? 'RED' : 'GREEN'
    })
  }, [_vm._v(_vm._s(_vm.compound2.CONTAINS_TOXICOPHORE ? 'YES' : 'NO'))])])])])])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md8": "",
      "lg9": "",
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": "",
      "lg6": "",
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "target-top__layout__summary-subtitle"
  }, [_vm._v("\n            DATA\n          ")]), _vm._v(" "), _c('v-layout', {
    staticClass: "pa-1",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%",
      "border-spacing": "0"
    },
    attrs: {
      "id": "data-table"
    }
  }, [_c('tr', [_c('td', {
    staticClass: "carousel-table-title-1"
  }, [_vm._v("Global Score/Rank")]), _vm._v(" "), _c('td', {
    staticClass: "carousel-table-value-1"
  }, [_vm._v(_vm._s(_vm.compound.data_compound.global_rank_text))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "carousel-table-title-1"
  }, [_vm._v("Global Score/Rank (default weights)")]), _vm._v(" "), _c('td', {
    staticClass: "carousel-table-value-1"
  }, [_vm._v(_vm._s(_vm.compound.data_compound.global_default_weight_rank_text))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "carousel-table-title-1"
  }, [_vm._v("Meets minimum quality criteria")]), _vm._v(" "), _c('td', {
    staticClass: "carousel-table-value-1"
  }, [_vm._v(_vm._s(_vm.compound.data_compound.suitable_probe))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "carousel-table-title-1"
  }, [_vm._v("Number of SAR compounds")]), _vm._v(" "), _c('td', {
    staticClass: "carousel-table-value-1"
  }, [_vm._v(_vm._s(_vm.compound.data_compound.sar_raw))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "carousel-table-title-1"
  }, [_vm._v("Number of inactive analogs")]), _vm._v(" "), _c('td', {
    staticClass: "carousel-table-value-1"
  }, [_vm._v(_vm._s(_vm.compound.data_compound.inactive_analogs_raw))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "carousel-table-title-1"
  }, [_vm._v("PAINS Alerts")]), _vm._v(" "), _c('td', {
    staticClass: "carousel-table-value-1"
  }, [_vm._v(_vm._s(_vm.compound.data_compound.pains_text))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "carousel-table-title-1"
  }, [_vm._v("Number of secondary targets tested")]), _vm._v(" "), _c('td', {
    staticClass: "carousel-table-value-1"
  }, [_vm._v(_vm._s(_vm.compound.data_compound.no_secondary_targets))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "carousel-table-title-1"
  }, [_vm._v("Number of secondary targets 10-fold selective")]), _vm._v(" "), _c('td', {
    staticClass: "carousel-table-value-1"
  }, [_vm._v(_vm._s(_vm.compound.data_compound.no_secondary_targets_selective))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "carousel-table-title-1"
  }, [_vm._v("Median Target Potency(nM)")]), _vm._v(" "), _c('td', {
    staticClass: "carousel-table-value-1"
  }, [_vm._v(_vm._s(_vm.compound.data_compound.median_target_potency))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "carousel-table-title-1"
  }, [_vm._v("Median Absolute Deviation")]), _vm._v(" "), _c('td', {
    staticClass: "carousel-table-value-1"
  }, [_vm._v(_vm._s(_vm.compound.data_compound.median_absolute_deviation))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "carousel-table-title-1"
  }, [_vm._v("SIC")]), _vm._v(" "), _c('td', {
    staticClass: "carousel-table-value-1"
  }, [_vm._v(_vm._s(_vm.compound.data_compound.selectivity_information_content.toFixed(2)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "carousel-table-title-1"
  }, [_vm._v("Number of cell lines tested")]), _vm._v(" "), _c('td', {
    staticClass: "carousel-table-value-1"
  }, [_vm._v(_vm._s(_vm.compound.data_compound.no_celllines))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "carousel-table-title-1"
  }, [_vm._v("Number of cell lines where the tool is active (< 10um)")]), _vm._v(" "), _c('td', {
    staticClass: "carousel-table-value-1"
  }, [_vm._v(_vm._s(_vm.compound.data_compound.no_celllines_active))])])])])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": "",
      "lg6": "",
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "target-top__layout__summary-subtitle"
  }, [_vm._v("\n            FEATURES\n            "), _c('v-icon', {
    staticClass: "features-more",
    attrs: {
      "id": "features-tooltip"
    }
  }, [_vm._v("info")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "icons-details"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "font-weight": "600",
      "padding": "0 0 2px 3px"
    }
  }, [_vm._v("When the icon is coloured it has the following meaning:")]), _vm._v(" "), _c('table', {
    staticClass: "icons-table"
  }, _vm._l((_vm.features), function(value, key) {
    return _c('tr', {
      key: key
    }, [_c('td', [_c('img', {
      staticStyle: {
        "background": "#ffffff"
      },
      attrs: {
        "src": value.imageValid,
        "height": "15",
        "width": "15"
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(value.textValidCompound))])])
  }))])], 1), _vm._v(" "), _c('div', {
    staticClass: "target-top__layout__summary-content-main"
  }, [_c('prb-features', {
    attrs: {
      "compound": _vm.compound.data_compound,
      "features": _vm.features
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "target-top__layout__summary-content-main"
  }, [_c('div', {
    staticStyle: {
      "height": "200px",
      "width": "100%"
    },
    attrs: {
      "id": "spider"
    }
  })])]), _vm._v(" "), _c('v-flex', {
    staticClass: "profile",
    attrs: {
      "xs12": "",
      "lg12": "",
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "target-top__layout__summary-subtitle"
  }, [_vm._v("\n            PROTEIN AFFINITY PROFILE "), _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:top",
      value: ({
        html: 'pActivity is the meadian of all pKi, pKd and pIC50 values for each target-compound pair'
      }),
      expression: "{ html: 'pActivity is the meadian of all pKi, pKd and pIC50 values for each target-compound pair' }",
      arg: "top"
    }]
  }, [_c('v-icon', {
    staticStyle: {
      "color": "#455A64",
      "margin-bottom": "5px",
      "cursor": "pointer"
    }
  }, [_vm._v("info")])], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "id": "bar-profile"
    }
  })])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c354d23"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/prb-compound/prb-compound-top/PrbCompoundTop.vue
// module id = 564
// module chunks = 1